const HardwareComponent = () => (
    <section id="ourplans" className="py-12 relative">
        <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-900/50 to-black"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-20">
                <h2 className="text-5xl sm:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600">
                    Nasze plany
                </h2>
                <p className="mt-4 text-xl text-gray-400">Narzędzia, które chcemy rozwijać</p>
            </div>

            <div className="max-w-2xl mx-auto">
                <div
                    className="group relative bg-white/5 backdrop-blur-sm rounded-3xl p-6 border border-white/10 transition-all duration-500 hover:bg-white/10 hover:border-orange-500/50">
                    <div
                        className="absolute inset-0 bg-gradient-to-br from-orange-500/20 to-transparent opacity-0 group-hover:opacity-100 rounded-3xl transition-opacity duration-500"></div>
                    <div className="relative z-10 text-center">
                        <h3 className="text-5xl font-bold text-orange-500 mb-6">CageEEG</h3>
                        <p>wygodny i wydajny zestaw EEG</p>
                        <p className="text-gray-400 text-lg mb-8">

                        </p>
                        <div className="grid grid-cols-2 gap-6 text-center max-w-md mx-auto">
                            <div>
                                <span className="text-gray-500 block mb-1">Kanały</span>
                                <span className="text-white font-semibold text-lg">16,32,62</span>
                            </div>
                            <div>
                                <span className="text-gray-500 block mb-1">Próbkowanie</span>
                                <span className="text-white font-semibold text-lg">&gt; 128Hz</span>
                            </div>
                            <div>
                                <span className="text-gray-500 block mb-1">Rozdzielczość</span>
                                <span className="text-white font-semibold text-lg">24-bit</span>
                            </div>
                            <div>
                                <span className="text-gray-500 block mb-1">Łączność</span>
                                <span className="text-white font-semibold text-sm md:text-lg ">WiFi/Bluetooth/USB</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
)

export default HardwareComponent
